import React, { useState } from "react";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { Document, Page, pdfjs } from "react-pdf";
import { useNavigate, useParams } from "react-router-dom";

import axios from "../../api/axios";

import { FaCalendarAlt } from "react-icons/fa";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import BottomNav from "../../components/BottomNav";
import HeaderWithBack from "../../components/HeaderWithBack";
import SendEmail from "../../components/modal/SendEmail";
import InfoModal from "../../components/modal/InfoModal";
import {
  useCancelOnlinePrescription,
  useSendPrescriptionEmail,
} from "../../hooks/usePrescriptionActions";
import { usePrescriptionDetail } from "../../hooks/usePrescriptionDetail";
import { usePrescriptionOrder } from "../../hooks/usePrescriptionOrder";
import { usePrescriptionTracking } from "../../hooks/usePrescriptionTracking";
import { useAuthStore } from "../../stores/authStores";
import "../../styles/styles.css"; // Sesuaikan path jika berbeda
import FullscreenLoading from "./Components/FullScreenLoader";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

type TrackingData = {
  order_id: string;
  status: string;
  updated_time: string;
};

const EprescriptionDetail: React.FC = () => {
  const navigate = useNavigate();
  const { prescriptionId } = useParams();
  const [prescriptionOrder, setPrescriptionOrder] = useState<any>(false);
  const [showPdf, setShowPdf] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const userData = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const email = userData ? userData.userData : null;
  const { data, isLoading, refetch } = usePrescriptionDetail(prescriptionId, token);
  const [insuranceNotice, setInsuranceNotice] = useState<string | null>(null);
  const [numPages, setNumPages] = useState<number | null>(null);
  const { data: orderData } = usePrescriptionOrder(prescriptionId, token);
  const { data: trackingData } = usePrescriptionTracking(prescriptionId, token);
  const sendEmailMutation = useSendPrescriptionEmail();
  const cancelMutation = useCancelOnlinePrescription();
  const prescriptionData = data?.data;
  const encToken = data?.encToken;
  const benefitInfo = data?.benefit;
  const prescriptionOrderData = orderData;
  const prescriptionOrderTracking: TrackingData[] = trackingData ?? [];

  const publicPdfUrl = prescriptionData?.pdf_url;
  const publicPdfUrlDownload = prescriptionData?.pdf_url_download;
  const handleDownloadPdf = () => {
    console.log("Public PDF URL:", publicPdfUrl); // Tambahkan ini
    if (publicPdfUrlDownload) {
      // setShowPdf(!showPdf);
      // setShowButton(false);
      const link = document.createElement("a");
      link.href = publicPdfUrlDownload;
      link.download = "resep_telekonsultasi.pdf"; // Saran: tambahkan ini untuk nama file default
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.warn("URL PDF tidak tersedia untuk diunduh.");
    }
  };

  let isExpired = false;
  const orderStatus = prescriptionOrderData?.order?.order_status;
  const paymentStatus = prescriptionOrderData?.transaction?.status_payment;
  const isPaidOrder = orderStatus === "paid" || paymentStatus === "payment";
  const order = prescriptionOrderData?.order;
  const transaction = prescriptionOrderData?.transaction;
  const hasNoOrder = !order;
  const isAlreadyDownloaded = prescriptionData?.download === 1;
  const canContinuePayment =
    order &&
    (order.order_status === "draft" ||
      order.order_status === "waiting_payment") &&
    (transaction?.status_payment === "draft" || transaction == null);
  const isPaid =
    order?.order_status === "paid" || transaction?.status_payment === "payment";
  const [showCancelOnlineModal, setShowCancelOnlineModal] = useState(false);
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const [isTebusSendiriMode, setIsTebusSendiriMode] = useState(false);
  const shouldShowPdf = isTebusSendiriMode || isAlreadyDownloaded;
  const totalBayar =
    Number(prescriptionOrderData?.invoice?.price_total) ||
    Number(prescriptionOrderData?.transaction?.detail?.price) ||
    Number(prescriptionOrderData?.order?.total_price) ||
    Number(prescriptionOrderData?.order?.shipping_cost) ||
    0;
  const rawInsuranceAmount = Number(benefitInfo?.ditanggung_asuransi || 0);
  const insurancePercent = Math.round(
    (benefitInfo?.persentase_cover_asuransi ?? 0) * 100,
  );
  const shippingTotal =
    Number(prescriptionOrderData?.order?.shipping_cost || 0) +
    Number(prescriptionOrderData?.order?.fee_service || 0);
  const drugItems =
    prescriptionOrderData?.transaction?.invoice?.items?.filter(
      (item: any) => item.itemable_type === "App\\Models\\Drug"
    ) || [];

  const invoiceDrugTotal = drugItems.reduce(
    (sum: number, item: any) => sum + Number(item.price_total || 0),
    0
  );
  const totalDrugPrice =
    invoiceDrugTotal > 0
      ? invoiceDrugTotal
      : Math.max(0, totalBayar - shippingTotal);
  const appliedInsuranceAmount = Math.max(0, rawInsuranceAmount);
  const participantDrugAmount = totalDrugPrice;
  const participantAmount = totalBayar;

  if (prescriptionData?.expired) {
    const [day, month, year] = prescriptionData.expired.split("-");
    const expiredDate = new Date(`${year}-${month}-${day}`);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    expiredDate.setHours(0, 0, 0, 0);

    isExpired = expiredDate < today;
  }

  const orderItems = data?.order_items ?? [];

  const orderItemsTotalDrug = orderItems.reduce(
    (sum: number, item: any) => sum + Number(item.price_total || 0),
    0
  );
  const displayTotalDrug = orderItems.length > 0 ? orderItemsTotalDrug : totalDrugPrice;

  const insuranceDeduction = benefitInfo?.eligible
    ? Number(benefitInfo.approved_amount ?? 0)
    : 0;
  const finalDrugAfterBenefit = Math.max(0, displayTotalDrug - insuranceDeduction);

  const handleSendEmail = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    if (!prescriptionId || !token) return;

    sendEmailMutation.mutate(
      { prescriptionId, token },
      {
        onSuccess: () => {
          alert("Berhasil mengirim resep");
          setShowButton(false);
          setShowModal(false);
        },
        onError: () => {
          alert("Gagal mengirim resep");
        },
      },
    );
  };

  const handleCheckout = async () => {
    try {
      navigate(`/e-prescription/checkout/${prescriptionId}/${encToken}`);
    } catch (err) {
      alert("Gagal memulai checkout");
    }
  };

  const handleTebusOnline = async () => {
    const fresh = (await refetch()).data ?? data;

    if (fresh?.insurance?.is_active === false) {
      setInsuranceNotice(fresh.insurance.message || "Masa asuransi Anda tidak aktif");
      return;
    }

    navigate(`/e-prescription/checkout/${prescriptionId}/${fresh?.encToken ?? encToken}`);
  };

  const handleTebusSendiri = async () => {
    if (prescriptionOrder) {
      await axios.post(
        `prescription/${prescriptionId}/cancel-online`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
    }

    setIsTebusSendiriMode(true);
    setShowPdf(true);
    setShowButton(true);
  };

  const handleConfirmTebusSendiri = () => {
    if (!prescriptionId || !token) return;

    setIsCancelLoading(true);

    cancelMutation.mutate(
      { prescriptionId, token },
      {
        onSuccess: () => {
          setShowCancelOnlineModal(false);
          handleTebusSendiri();
        },
        onError: () => {
          alert("Gagal membatalkan tebus online");
        },
        onSettled: () => {
          setIsCancelLoading(false);
        },
      },
    );
  };

  console.log({
    order: prescriptionOrderData,
  });

  return (
    <div className="min-h-screen bg-white flex flex-col pb-20">
      {/* Header */}
      <HeaderWithBack title="E-Prescription" url="/e-prescription" />

      {/* Info Resep */}
      <div className="bg-teal-500 text-white px-4 py-2 flex items-center">
        <FaCalendarAlt className="mr-2" />
        <span>Resep Online Anda</span>
      </div>

      {prescriptionData?.expired &&
        (!prescriptionOrder || prescriptionData?.download !== 1) &&
        (isExpired ? (
          <div className="bg-red-500 text-white px-4 py-2 text-sm text-center">
            Resep Sudah Kadaluarsa <br />{" "}
            <strong>{prescriptionData.expired}</strong>
          </div>
        ) : (
          <div className="bg-yellow-100 text-yellow-800 px-4 py-2 text-sm text-center">
            Lakukan penebusan obat sebelum <br />{" "}
            <strong>{prescriptionData.expired}</strong>
          </div>
        ))}

      {/* Resep Digital */}
      <div className="px-4 mt-4">
        <div className="bg-white border rounded-md shadow-sm p-4">
          <h2 className="font-semibold text-gray-800 mb-2">Resep Digital</h2>
          <div className="flex items-center border rounded-md p-3 mb-3">
            <img
              src={prescriptionData?.avatar_doctor}
              alt="doctor"
              className="w-10 h-10 rounded-full mr-3"
            />
            <div>
              <p className="font-semibold text-sm">
                {prescriptionData?.doctor}
              </p>
              <p className="text-xs text-gray-500">
                {prescriptionData?.specialty}
              </p>
            </div>
          </div>

          <div className="flex justify-between items-center text-sm mb-2">
            <p className="font-semibold">R/ {prescriptionData?.code}</p>
            <p className="text-gray-500">
              Tanggal Konsultasi: <br /> {prescriptionData?.date}
            </p>
          </div>

          {prescriptionData?.items?.map((item: any, index: number) => (
            <div
              key={index}
              className="border px-3 py-2 rounded-md text-sm bg-gray-50 mb-2"
            >
              {item?.drug_name} x {item?.qty} {item?.unit} ({item?.frequency_dd}{" "}
              x {item?.frequency})
            </div>
          ))}

          {/* Catatan Alergi */}
          <div className="mt-4">
            <h3 className="font-semibold text-sm mb-2">Catatan Alergi :</h3>
            {prescriptionData?.allergies.length ? (
              prescriptionData?.allergies?.map((alergi: any, index: number) => (
                <div key={index} className="border rounded-md p-2 mb-2 text-sm">
                  <p className="font-semibold">{alergi?.allergy}</p>
                  <p className="text-gray-500">
                    Catatan : {alergi?.allergy_note || "-"}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">Tidak ada catatan alergi</p>
            )}
          </div>
        </div>
      </div>
      {isPaidOrder ? (
        <>
          {/* Detail Pengiriman */}
          <div className="px-4 mt-4">
            <div className="border shadow rounded bg-white">
              <div className="flex p-4">
                {/* Ikon sesuai tampilan original */}
                <img
                  src="https://m.linksehat.com/assets/img/icons/delivery-order-icon.png"
                  alt="Delivery Icon"
                  className="h-[30px]"
                />
                <div className="px-4 self-center text-gray-700 w-full">
                  Detail Pengirim
                </div>
                <div className="px-4 self-center text-gray-700 ml-auto">
                  Apotek K24
                </div>
              </div>

              <div className="px-4 pb-4">
                <div>
                  <span className="font-bold">
                    {prescriptionOrderData.order?.outlet}
                  </span>
                </div>
                <div>
                  <span>{prescriptionOrderData.order?.shipping_method}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="px-4 mt-4">
            <div className="bg-white border rounded-md shadow-sm p-4">
              {/* Header dengan Icon dan Judul */}
              <div className="flex items-center mb-3">
                <div className="bg-teal-100 text-teal-600 p-2 rounded-full mr-2">
                  <i className="fas fa-box-open"></i>
                </div>
                <h2 className="font-semibold text-gray-800 text-sm">
                  Detail Paket
                </h2>
              </div>

              {/* Detail Pesanan */}
              <div className="text-sm mb-4">
                <p className="font-semibold mb-1">Detail Pesanan :</p>
                <div className="space-y-2">
                  {(orderItems.length > 0 ? orderItems : prescriptionData?.items)?.map(
                    (item: any, index: number) => {
                      const isSubstituted = item.is_substituted ?? false;
                      const priceTotal    = item.price_total ?? drugItems[index]?.price_net ?? 0;

                      return (
                        <div key={index}>
                          <div className="flex justify-between items-start">
                            <div className="flex-1 pr-2">
                              <p className="text-sm">
                                {item.drug_name ?? item?.drug_name}{" "}
                                <span className="text-gray-500">
                                  x {item.qty ?? item?.quantity}
                                </span>
                              </p>

                              {isSubstituted && (
                                <span className="inline-block mt-0.5 text-xs bg-orange-50 text-orange-600 border border-orange-200 px-2 py-0.5 rounded-full">
                                  Obat diganti (substitusi)
                                </span>
                              )}

                              {item.price_per_unit != null && (
                                <p className="text-xs text-gray-400 mt-0.5">
                                  Rp {Number(item.price_per_unit ?? 0).toLocaleString("id-ID")} / pcs
                                </p>
                              )}
                            </div>

                            <span className="text-sm whitespace-nowrap">
                              Rp {Number(priceTotal ?? 0).toLocaleString("id-ID")}
                            </span>
                          </div>
                        </div>
                      );
                    }
                  )}

                  <div className="flex justify-between font-semibold border-t pt-2">
                    <span>Total Obat</span>
                    <span>Rp {Number(displayTotalDrug ?? 0).toLocaleString("id-ID")}</span>
                  </div>

                  {benefitInfo?.eligible && (
                    <>
                      <div className="flex justify-between text-sm items-center text-emerald-600">
                        <span className="flex items-center gap-1.5">
                          <i className="fas fa-shield-alt text-xs"></i>
                          Benefit Asuransi ({benefitInfo.persentase_cover}%)
                        </span>
                        <span className="font-medium">
                          - Rp {Number(benefitInfo.approved_amount ?? 0).toLocaleString("id-ID")}
                        </span>
                      </div>

                      <div className="flex justify-between font-semibold border-t pt-2 text-gray-800">
                        <span>Total Obat (Setelah Benefit)</span>
                        <span>Rp {Number(finalDrugAfterBenefit).toLocaleString("id-ID")}</span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Biaya dan Total */}
              <div className="text-sm mb-4">
                <div className="flex justify-between">
                  <span>Biaya Pengiriman</span>
                  <span>
                    Rp {Number(prescriptionOrderData?.order?.shipping_cost ?? 0).toLocaleString("id-ID")}
                  </span>
                </div>
                {/* <div className="flex justify-between">
                  <span>Potongan Ongkos Kirim</span>
                  <span>
                    - Rp{" "}
                    {prescriptionOrderData?.invoice?.discount.toLocaleString(
                      "id-ID",
                    )}
                  </span>
                </div> */}
                <div className="flex justify-between font-bold">
                  <span>Total Pesanan</span>
                  <span>
                    Rp {Number(totalBayar ?? 0).toLocaleString("id-ID")}
                  </span>
                </div>
              </div>

              {/* Metode Pembayaran */}
              <div className="text-sm mb-2">
                <p className="font-semibold mb-1">Metode Pembayaran :</p>
                <div className="pl-2">
                  <p>
                    <span>Biller Code: </span>
                    {prescriptionOrderData.transaction?.merchant_code}
                  </p>
                  <p>
                    <span>Bill Key: </span>
                    {prescriptionOrderData.transaction?.va}
                  </p>
                  {prescriptionOrderData.transaction?.status_payment !==
                  "payment" ? (
                    <p>
                      <span>Bayar Sebelum : </span>
                      {prescriptionOrderData.transaction?.expired_date}
                    </p>
                  ) : null}
                </div>
              </div>

              {/* Total Bayar & Status */}
              <div className="text-sm">
                <div className="flex justify-between font-bold">
                  <span>Total Bayar:</span>
                  <span>Rp {Number(totalBayar ?? 0).toLocaleString("id-ID")}</span>
                </div>
                <p className="mt-1">
                  <span className="font-bold">Status: </span>
                  {prescriptionOrderData.transaction?.status_payment === "payment" ? (
                    <span className="text-green-600">Sudah Dibayar</span>
                  ) : (
                    <span className="font-bold">Menunggu Pembayaran</span>
                  )}
                </p>

                {benefitInfo?.eligible && (
                  <div className="mt-3 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 flex items-start gap-2">
                    <span className="text-emerald-700 text-xs font-medium">
                      {benefitInfo.note}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="px-4 mt-4">
            <div className="bg-white border rounded-md shadow-sm p-4">
              {/* Header Icon & Title */}
              <div className="flex items-center mb-3">
                <div className="bg-teal-100 text-teal-600 p-2 rounded-full mr-2">
                  <i className="fas fa-truck"></i>
                </div>
                <h2 className="font-semibold text-gray-800 text-sm">
                  Status Pengiriman
                </h2>
              </div>

              {/* List Status */}
              <ul className="text-sm space-y-2 pl-2">
                {isLoading ? (
                  <li className="text-gray-500 italic">Memuat status...</li>
                ) : prescriptionOrderTracking.length > 0 ? (
                  prescriptionOrderTracking.map((data, key) => (
                    <li key={key} className="flex flex-col items-start">
                      <div className="flex items-start">
                        <span
                          className={`h-3 w-3 rounded-full mr-2 mt-1 bg-teal-500`}
                        ></span>
                        <span className="text-gray-700">{data.status}</span>
                      </div>
                      <span className="text-xs text-gray-500 pl-5">
                        {data.updated_time}
                      </span>
                    </li>
                  ))
                ) : (
                  <li className="text-gray-500">Belum ada status.</li>
                )}
              </ul>
            </div>

            {/* WhatsApp Button */}
            <div className="mt-4 flex justify-center">
              <a
                href="https://wa.me/6281390002249?text=Halo%20Admin%2C%20saya%20ingin%20bertanya%20tentang%20status%20pengiriman%20obat"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center"
              >
                <i className="fab fa-whatsapp mr-2"></i> HUBUNGI VIA WHATSAPP
              </a>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {/* Tombol Tebus Online & Tebus Sendiri */}
      {/* {isLoading ?
  <FullscreenLoading />
  :
  !isLoading && !isExpired && (
      <div className="mt-4">
        <div className="flex p-4">
          <div className="flex">
            <button
              type="submit"
              onClick={() => navigate(`/e-prescription/checkout/${prescriptionId}/${encToken}`)}
              className="p-2 mr-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
            >
              <i className="fas fa-shopping-cart mr-2"></i> Tebus Online
            </button>
            <button
              onClick={handleTebusSendiri}
              type="button"
              className="p-2 bg-teal-600 rounded text-white text-sm flex items-center"
            >
              <i className="fas fa-download mr-2"></i> Tebus Sendiri
            </button>
          </div>
        </div>
      </div>
    )}
    {!isLoading && !isExpired && hasNoOrder && (
  <div className="mt-4 p-4 flex gap-2">
    <button
      onClick={() =>
        navigate(`/e-prescription/checkout/${prescriptionId}/${encToken}`)
      }
      className="p-2 bg-teal-500 rounded text-white flex items-center"
    >
      <i className="fas fa-shopping-cart mr-2"></i>
      Tebus Online
    </button>

    <button
      onClick={handleTebusSendiri}
      className="p-2 bg-teal-600 rounded text-white flex items-center"
    >
      Tebus Sendiri
    </button>
  </div>
)} */}

      {isLoading && <FullscreenLoading />}

      {!isLoading && !isExpired && !isPaid && !isAlreadyDownloaded && (
        <div className="mt-4 p-4 flex gap-2">
          {hasNoOrder && (
            <>
              <button
                onClick={handleTebusOnline}
                className="p-2 bg-teal-500 rounded text-white flex items-center"
              >
                <i className="fas fa-shopping-cart mr-2"></i>
                Tebus Online
              </button>

              <button
                onClick={handleTebusSendiri}
                className="p-2 bg-teal-600 rounded text-white flex items-center"
              >
                Tebus Sendiri
              </button>
            </>
          )}
          {canContinuePayment && (
            <>
              <button
                onClick={handleTebusOnline}
                className="p-3 bg-orange-500 text-white rounded font-semibold"
              >
                <i className="fas fa-credit-card mr-2"></i>
                Lanjutkan Pembayaran
              </button>

              <button
                onClick={() => setShowCancelOnlineModal(true)}
                className="p-2 bg-teal-600 rounded text-white flex items-center"
              >
                Tebus Sendiri
              </button>
            </>
          )}
          {showCancelOnlineModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg w-[90%] max-w-md p-6">
                <h3 className="text-lg font-semibold mb-2">
                  Ganti ke Tebus Sendiri?
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Jika kamu melanjutkan, proses tebus online akan dibatalkan dan
                  kamu tidak bisa melanjutkan pembayaran secara online.
                </p>
                <div className="flex justify-end gap-2">
                  <button
                    disabled={isCancelLoading}
                    onClick={() => setShowCancelOnlineModal(false)}
                    className="px-4 py-2 rounded bg-gray-200 text-gray-700"
                  >
                    Batal
                  </button>

                  <button
                    disabled={isCancelLoading}
                    onClick={handleConfirmTebusSendiri}
                    className="px-4 py-2 rounded bg-red-600 text-white"
                  >
                    {isCancelLoading ? "Memproses..." : "Ya, Tebus Sendiri"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {isExpired && prescriptionData?.download !== 1 && (
        <div className="mt-4">
          <div className="flex p-4">
            <div className="flex">
              <button
                type="submit"
                onClick={() => navigate(`/home`)}
                className="p-2 mr-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
              >
                <i className="fas fa-sync-alt mr-2"></i> Konsultasi Ulang
              </button>
            </div>
          </div>
        </div>
      )}

      {shouldShowPdf ? (
        <div className="mt-4 border rounded p-4 bg-white">
          {isTebusSendiriMode && (
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <div className="flex items-center gap-2 mb-2">
                <i className="fas fa-exclamation-triangle text-yellow-500"></i>
                <h3 className="text-sm font-semibold">Perhatian!</h3>
              </div>

              <p className="text-sm text-gray-600 mb-2">
                Kamu memilih <b>Tebus Sendiri</b>. Perlu diketahui:
              </p>

              <ul className="text-sm text-gray-600 space-y-1 pl-4 list-disc">
                <li>Resep akan ditampilkan dan bisa diunduh</li>
                <li className="text-red-600 font-medium">
                  Tebus Online <b>tidak bisa dilakukan</b> setelah ini
                </li>
                <li>Bawa resep ke apotek terdekat untuk menebus obat</li>
                {data?.insurance?.is_active === false && (
                  <li className="text-red-600 font-medium">
                    Masa asuransi Kamu sudah tidak aktif, biaya obat sepenuhnya ditanggung sendiri (tanpa benefit asuransi)
                  </li>
                )}
              </ul>
            </div>
          )}

          <Document
            file={publicPdfUrl}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={window.innerWidth - 64}
              />
            ))}
          </Document>
          {!isExpired && showButton ? (
            <div className="mt-4">
              <div className="flex flex-wrap gap-2 p-4">
                {/* Tombol Kirim Online */}
                {/* <button
                  type="submit"
                  onClick={handleSendEmail}
                  className="p-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
                >
                  <i className="fas fa-paper-plane mr-2"></i> Kirim Email
                </button> */}

                {/* Tombol Download */}
                <button
                  onClick={handleDownloadPdf}
                  type="button"
                  className="p-2 bg-teal-600 rounded text-white text-sm flex items-center"
                >
                  <i className="fas fa-file-download mr-2"></i> Download
                </button>

                {/* Tombol Batal */}
                <button
                  onClick={() => setShowPdf(false)}
                  type="button"
                  className="p-2 bg-gray-500 rounded text-white text-sm flex items-center"
                >
                  <i className="fas fa-times-circle mr-2"></i> Batal
                </button>

                <SendEmail
                  isOpen={showModal}
                  onClose={() => setShowModal(false)}
                  onConfirm={handleConfirm}
                  email={email}
                />
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      <InfoModal
        show={!!insuranceNotice}
        title="Masa Asuransi Tidak Aktif"
        message={`${insuranceNotice || ""}. Tebus online tidak dapat dilakukan. Kamu tetap dapat memilih Tebus Sendiri dengan mengunduh resep ini.`}
        onClose={() => setInsuranceNotice(null)}
      />

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default EprescriptionDetail;
